import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';
import * as style from './ModalNewResearch.module.less';
import { observable } from 'mobx';
import { ReactNode, useEffect, useRef, useState } from 'react';
import right_art from './modal.png';
import { Split } from '../Split/Split';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { getFirebase } from '@assets/firebase/FirebaseAdapater';
import { useClientSettingStore, useStoreUI } from '@assets/model/Store';
import { Typeahead, TypeaheadRef } from 'react-bootstrap-typeahead';

class NewResearchStore {
    constructor() {}

    @observable
    accessor company_name: string = '';

    @observable
    accessor website: string = '';

    @observable
    accessor description: string = '';

    @observable accessor industry: string = '';
    @observable accessor sub_industry: string = '';
}

interface SelectIndustryProps {
    store: NewResearchStore;
}
const SelectIndustry = observer((p: SelectIndustryProps) => {
    const industry = useClientSettingStore().industryTypes;
    const options = industry.map(industry => {
        var name = industry.name;
        return { label: name, value: name, industry: name };
    });

    return (
        <Typeahead
            allowNew={false}
            // className={style.editIndustry}
            // dropup={true}
            id="typeahead-industry-edit"
            labelKey="label"
            positionFixed={true}
            onChange={selected => {
                if (selected.length > 0) {
                    p.store.industry = selected[0]['value'];
                }
            }}
            options={options}
            filterBy={() => true}
            placeholder={'Select Industry'}
        />
    );
});

const SelectSubIndustry = observer((p: SelectIndustryProps) => {
    const typeaheadRef = useRef<TypeaheadRef>(null);
    const industry = useClientSettingStore().industryTypes;
    const industryValue = p.store.industry;

    const find_industry = industry.find(
        industry => industry.name == industryValue
    );
    var options = [];
    if (find_industry) {
        options = find_industry.subtypes.map(industry => {
            var name = industry.name;
            return { label: name, value: name, industry: name };
        });
    }

    useEffect(() => {
        typeaheadRef.current.clear();
        p.store.sub_industry = '';
    }, [p.store.industry]);

    return (
        <Typeahead
            allowNew={false}
            ref={typeaheadRef}
            disabled={options.length == 0}
            id="typeahead-industry-edit"
            labelKey="label"
            positionFixed={true}
            onChange={selected => {
                if (selected.length > 0) {
                    p.store.sub_industry = selected[0]['value'];
                }
            }}
            filterBy={() => true}
            options={options}
            placeholder={'Select Sub-Industry'}
        />
    );
});
export const ModalNewResearch = observer(() => {
    const [store] = useState(new NewResearchStore());
    const wrap_typeahead = (label: string, el: ReactNode) => {
        return (
            <div style={{ marginBottom: '5px' }}>
                <label className={style.label}>{label}</label>
                {el}
            </div>
        );
    };
    const create_textbox = (label: string, field: keyof NewResearchStore) => {
        return (
            <div>
                <label className={style.label}>{label}</label>
                <input
                    type="text"
                    className={style.input_text}
                    value={store[field]}
                    onInput={e => {
                        store[field] = e.currentTarget.value;
                    }}
                    placeholder={label}
                />
            </div>
        );
    };

    const create_textarea = (label: string, field: keyof NewResearchStore) => {
        return (
            <div>
                <label className={style.label}>{label}</label>
                <textarea
                    rows={3}
                    className={classNames(
                        style.input_text,
                        style.input_textarea
                    )}
                    value={store[field]}
                    onInput={e => {
                        store[field] = e.currentTarget.value;
                    }}
                    placeholder={label}
                />
            </div>
        );
    };

    const onAddResarch = () => {
        const fb = getFirebase();
        fb.add_research_job(
            'Research',
            store.company_name,
            store.industry,
            store.website,
            '',
            null,
            true,
            true,
            store.description
        );
        const uiStore = useStoreUI();
        uiStore.modal = null;
    };

    const canAddJob =
        store.company_name.trim().length > 0 &&
        store.industry.trim().length > 0 &&
        store.website.trim().length > 0 &&
        store.description.trim().length > 0;
    const elements = [];
    elements.push(create_textbox('Company Name', 'company_name'));
    //elements.push(create_textarea('Industry', 'industry'));
    elements.push(
        wrap_typeahead(
            'Industry',
            <SelectIndustry key="select_industry" store={store} />
        )
    );
    // elements.push(
    //     wrap_typeahead(
    //         'Sub-Industry',
    //         <SelectSubIndustry key="select_sub_industry" store={store} />
    //     )
    // );
    elements.push(create_textbox('Website', 'website'));
    elements.push(create_textarea('Description', 'description'));
    elements.push(<div style={{ flex: 1 }}></div>);
    elements.push(
        <Button
            variant="light"
            className={style.addButton}
            onClick={onAddResarch}
            disabled={!canAddJob}
        >
            Create Case
        </Button>
    );

    return (
        <Split layoutPercent={[50, 50]} spaceBetween={40}>
            <Flex fillCell={true} direction="column">
                {elements}
            </Flex>
            <Flex fillCell={true} direction="column">
                <img src={right_art} className={style.rightImage} />
            </Flex>
        </Split>
    );
});
